import moment from 'moment';

export default function dataToForm(event) {
  const newLinks = [];
  for (let i = 0; i < event.LINKS.length; i += 1) {
    const link = {
      url: event.LINKS[i].LINK_URL || '',
      text: event.LINKS[i].LINK_TEXT || ''
    };
    newLinks.push(link);
  }
  return {
    event_id: event.EVENT_ID,
    name: event.EVENT_NAME,
    start_date: moment(event.START_DATE, 'YYYY-MM-DD').format('D.M.YYYY'),
    end_date: moment(event.END_DATE, 'YYYY-MM-DD').format('D.M.YYYY'),
    description: event.DESCRIPTION,
    participant: event.PARTICIPANT,
    lon: event.LON,
    lat: event.LAT,
    scope: event.SCOPE,
    executor: event.EXECUTOR,
    contact_name: event.CONTACT_NAME,
    contact_email: event.CONTACT_EMAIL,
    contact_phone: event.CONTACT_PHONE,
    keywords: event.KEYWORDS,
    links: newLinks
  };
}



// WEBPACK FOOTER //
// ./src/services/dataToForm.js